import dynamic from 'next/dynamic'

import { BackendChallengeType } from '../backend.types'

const NormalBackendChallengeDynamic = dynamic(
  () => import('../pages/NormalBackendChallenge')
)

const BetaEditorBackendChallengeDynamic = dynamic(
  () => import('../pages/BetaEditorBackendChallenge')
)

export const getBackendChallenge = (type: BackendChallengeType) => {
  switch (type) {
    case 'normal':
      return NormalBackendChallengeDynamic
    case 'stackblitz':
      return BetaEditorBackendChallengeDynamic
  }
}
